import type {
    ReviewsListItemDataForAd,
    ReviewsListRatingBreakdownItemData,
} from '@frontend/modules/public/shared/reviews/ReviewsModuleTypes'
import type {ApiResponseData} from '@frontend/types/AppTypes'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import type {SellerDetailsData} from './SellerInfoModuleTypes'

// Сервис взаимодействия пользователя с продавцами.
export const SellersApi = {

    // Получить данные о продавце.
    async getDetails(userId: number): Promise<GetSellerDetailsResponseData> {
        return ApiRequestService
            .get<GetSellerDetailsResponseData>(`/v1/seller/${userId}`)
            .then(response => response.data)
    },

    // Получить список отзывов о продавце.
    async getReviews(
        userId: number,
        limit: number,
        offset: number = 0
    ): Promise<UserReviewsListResponseData> {
        return ApiRequestService
            .get<UserReviewsListResponseData>(`/v1/seller/${userId}/reviews`, {
                limit: String(limit),
                offset: String(offset),
            })
            .then(response => response.data)
    },
}

interface GetSellerDetailsResponseData extends ApiResponseData {
    seller: SellerDetailsData
    isSubscribed: boolean
}

interface UserReviewsListResponseData extends ApiResponseData {
    records: ReviewsListItemDataForAd[]
    ratingBreakdown: ReviewsListRatingBreakdownItemData[] | null
}
